export enum EPageContainer {
  Authentication = 'authentication',
  NewPassword = 'newPassword',
  SocialLogin = 'socialLogin',
}
